import { SupabaseTableBase } from '../../utils/SupabaseTableBase';
import { preserveSummaryLineBreaks } from '../../utils/shortSummaryParser';
import { CallSummary } from './types';

export class CallSummaryService extends SupabaseTableBase<CallSummary> {
  constructor() {
    super('CallSummery');
  }

  async createSummary(callId: string, summary: string, timestamp?: string): Promise<CallSummary | null> {
    const summaryData = {
      callId,
      summary: preserveSummaryLineBreaks(summary),
      ...(timestamp && { created_at: timestamp })
    };

    const result = await this.insertRecord(summaryData);
    return result.data;
  }

  async getSummariesByCallId(callId: string): Promise<CallSummary[]> {
    const result = await this.selectRecordsByColumn('callId', callId, {
      orderBy: 'created_at',
      ascending: false
    });

    return result.data || [];
  }
}